import { useCallback } from 'react';
import { CANCELLED_BY_USER, useModal } from 'src/shared/modalProvider';
import { TARIFF_SELECT_MODAL } from '../lib';
import { TariffModalResult } from './types';

export const useTariffModalProvider = (): ((tariffId?: number) => Promise<TariffModalResult>) => {
  const { openModal, closeModal } = useModal();
  return useCallback(
    (tariffId) =>
      new Promise((resolve, reject) => {
        openModal(TARIFF_SELECT_MODAL.nss, {
          fullscreen: true,
          tariffId,
          onModalDestroy: () => {
            reject(CANCELLED_BY_USER);
          },
          onCancel: () => {
            closeModal(TARIFF_SELECT_MODAL.nss);
            reject(CANCELLED_BY_USER);
          },
          onFailure: () => {
            closeModal(TARIFF_SELECT_MODAL.nss);
            reject(CANCELLED_BY_USER);
          },
          // @ts-expect-error refactor openModal types
          onSuccess: (p: TariffModalResult) => {
            resolve(p);
            closeModal(TARIFF_SELECT_MODAL.nss);
          },
        });
      }),
    [openModal, closeModal],
  );
};
